import { VListItem } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VListItem,{staticClass:"my-1",attrs:{"color":"primary","block":_vm.block,"disabled":!_vm.disabled,"small":"","loading":_vm.isBusy},on:{"click":_vm.onDownloadTemplate}},[_vm._v(" Export ")])
}
var staticRenderFns = []

export { render, staticRenderFns }